export const OAUTH_FORM = "oauthForm";